module.exports = __webpack_public_path__ + "resources/east-express-bank.png";